module.exports = __webpack_public_path__ + "crm_static/img/04.53162434.png";